import { TRevenueSnapshotKeys } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { getStrSeparatedByUpperCase } from '../../../../helpers/getStrSeparatedByUpperCase'
import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

export const getRevenueItemName = (key: TRevenueSnapshotKeys) => {
  return getFormedEltTranslation(getStrSeparatedByUpperCase(key))
}
